import { UpdateTopicOrderRequest } from '@models/marketing/topics/topics.model';
import { patchState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, EMPTY, pipe, switchMap, tap } from 'rxjs';
import { RecordingsService } from '../recordings.service';
import { RecordingsStore } from '../recordings.store';

export const getRecordingsTopicsOrderMethods = (injects: { store: RecordingsStore; recordingsService: RecordingsService }) => {
  const { store, recordingsService } = injects;

  const getTopicsOrder = rxMethod<void>(
    pipe(
      tap(() => patchState(store, { isTopicsOrderLoading: true })),
      switchMap(() =>
        recordingsService.getTopicsOrder().pipe(
          tap(topicsOrder => patchState(store, { topicsOrder, isTopicsOrderLoading: false })),
          catchError(() => {
            patchState(store, { isTopicsOrderLoading: false });
            return EMPTY;
          }),
        ),
      ),
    ),
  );

  const setTopicsOrder = rxMethod<UpdateTopicOrderRequest>(
    pipe(
      tap(() => patchState(store, { isSetTopicsOrderLoading: true })),
      switchMap(topicsOrder =>
        recordingsService.setTopicsOrder(topicsOrder).pipe(
          tap(topicsOrder => {
            patchState(store, { topicsOrder, isSetTopicsOrderLoading: false });
          }),
          catchError(() => {
            patchState(store, { isSetTopicsOrderLoading: false });
            return EMPTY;
          }),
        ),
      ),
    ),
  );

  return {
    getTopicsOrder,
    setTopicsOrder,
  };
};

export interface RecordingTopicsOrderStoreType {
  readonly getTopicsOrder: () => void;
  readonly setTopicsOrder: (topicsOrder: UpdateTopicOrderRequest) => void;
}
